import React, { FC, useEffect, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import { preworkDataStore, checkRequired } from 'src/store/preworkInfo';
import InputBox from 'src/components/atoms/input/DefInputBox';
import IconButton from 'src/components/atoms/buttons/IconButton';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ type = '', data }) => {
  const preworkPayload = preworkDataStore((state: any) => state.payload);
  const bindPreworkPayload = preworkDataStore((state: any) => state.bindPayload);
  const inpStatus = type === 'list' ? '_read' : '';

  // view type
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    bindPreworkPayload({ ...preworkPayload, [key]: e.target.value });
  };
  const inpChangeNumberEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const value: any = e.target?.value.replace(/[^0-9]/g, ''); // 숫자만 허용
    bindPreworkPayload({ ...preworkPayload, [key]: Number(value) });
  };
  const labelStyle = { width: '170px', color: '#777', fontSize: '13px' };
  const boxStyle = { fontSize: '15px', fontWeight: '700' };

  return (
    <div className={['_comp_before_detail_content_div _active', inpStatus].join(' ')}>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'ppen_national')}
            // inputRef={inpRef}
            label="국민연금보험료"
            labelPosition="left"
            value={addComma(preworkPayload.ppen_national || 0)}
            required={type !== 'list' ? checkRequired('ppen_national') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'ppen_gov')}
            // inputRef={inpRef}
            label="공무원연금"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.ppen_gov || 0)}
            required={type !== 'list' ? checkRequired('ppen_gov') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'ppen_military')}
            // inputRef={inpRef}
            label="군인연금"
            labelPosition="left"
            value={addComma(preworkPayload.ppen_military || 0)}
            required={type !== 'list' ? checkRequired('ppen_military') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'ppen_private_school')}
            // inputRef={inpRef}
            label="사립학교교직원연금"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.ppen_private_school || 0)}
            required={type !== 'list' ? checkRequired('ppen_private_school') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>

      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'ppen_postal')}
            // inputRef={inpRef}
            label="별정우체국연금"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.ppen_postal || 0)}
            required={type !== 'list' ? checkRequired('ppen_postal') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridList;
